import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';
import IconLoadBalancer from './icons/LoadBalancer';
import * as Tooltip from './Tooltip';

const SubContactTitle = ({ children, parentName, onOpenMainContact }) => {
  const { t } = useTranslation('components');
  return (
    <div className="flex items-center">
      <div className="truncate">{children}</div>
      <Tooltip.Wrapper>
        <Tooltip.Title className="flex space-x-1">
          {({ hide }) => (
            <>
              <div>{t('SubContactTitle.represented_by')}</div>
              <button
                type="button"
                className="focus:outline-none underline"
                onClick={e => {
                  e.preventDefault();
                  hide();
                  onOpenMainContact();
                }}
              >
                {parentName}
              </button>
            </>
          )}
        </Tooltip.Title>
        <Tooltip.Trigger>
          <div>
            <IconLoadBalancer size="text" className="text-xs text-slate-500 flex-shrink-0" />
          </div>
        </Tooltip.Trigger>
      </Tooltip.Wrapper>
    </div>
  );
};

SubContactTitle.defaultProps = {
  onOpenMainContact: () => {},
  parentName: null,
  children: null,
};

SubContactTitle.propTypes = {
  children: PropTypes.node,
  parentName: PropTypes.string,
  onOpenMainContact: PropTypes.func,
};

export default SubContactTitle;
